import { Button } from '@chakra-ui/react';
import { ReactElement } from 'react';

type Props = {
  title: string;
  onClick: () => void;
};

export const ActionButton = ({ title, onClick }: Props): ReactElement | null => {
  const handleClick = async (): Promise<void> => {
    onClick();
  };

  return (
    <Button variant="secondary" onClick={handleClick}>
      {title}
    </Button>
  );
};
